
const digest = 'a6b2230b66efbd0f1f5e5a9093c88d18d50bb23602a750a7f9f7aa8dca74fd08';
const classes = {"wrapper":"_wrapper_xk4k1_1","text":"_text_xk4k1_6","controls":"_controls_xk4k1_11"};
const css = `._wrapper_xk4k1_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_xk4k1_1 ._text_xk4k1_6 {
  font-size: 14px;
  font-weight: 500;
  color: #d81616;
}
._wrapper_xk4k1_1 ._controls_xk4k1_11 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  